// #flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description = "The Big Numbers module displays a grid of numbers to quickly convey a collection of  bite-sized facts and figures.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Big numbers",
  id: "big-numbers",
  warningMsgOnConfigOverlay: {
    head: "Warning:",
    body: "You have changed the shape of this gallery. Existing images will remain cropped to their old shapes so please ensure you re-crop them to the new sizes.",
  },
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/big-numbers/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(
        "app/components/tools/BigNumbersConfigTool/BigNumbersConfigTool"
      ),
    loading: DynamicImportLoader,
    modules: ["BigNumbersConfigTool"],
  }),
};

export default CONFIG;
